import React, { useEffect } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider, Global } from '@emotion/react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { StyledGlobal } from '@/assets/styles/Global';
import { tryLoadMeiqiaWidget } from '@/utils/loadMeiqia';
import Router from './Router';
import "@/assets/styles/web.css"

const emotionCache = createCache({
  key: 'key',
  container: document.body,
});
const App = () => {
  useEffect(() => {
    tryLoadMeiqiaWidget();
  }, []);
  return (
    <CacheProvider value={emotionCache}>
      <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
        <Global styles={StyledGlobal} />
        <Router />
      </ConfigProvider>
    </CacheProvider>
  );
};

export default App;
